<template>
    <b-card no-body :class="options.classes" class="c-card-line-chart">
        <b-card-body class="pb-0">
            <slot name="body"></slot>
            <div class="h4 mb-0">{{value}}</div>
            <small class="text-uppercase font-weight-bold">{{caption}}</small>
        </b-card-body>
        <ChartLineSmall
                v-if="chart.labels !== undefined && chart.sets !== undefined"
                :labels="chart.labels"
                :sets="chart.sets"
                :chartId="chartId"
                class="chart-wrapper px-3" style="height:70px;" :height="70"></ChartLineSmall>
        <slot name="footer"></slot>
    </b-card>
</template>

<script>
    import ChartLineSmall from './ChartLineSmall'
    export default {
        name: 'CardChartLineSmall',
        components: {
            ChartLineSmall
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        classes: ''
                    }
                }
            },
            chartId: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: ''
            },
            value: {
                type: String|Number,
                default: ''
            },
            chart: {
                type: Object,
                default: function() {
                    return {
                    }
                }
            }
        },
        data: () => {
            return {
            }
        }
    }
</script>
